






















import {
  Vue, Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';
import RestaurantsChart from '@/components/Stats/MarketStats/ProfileStats/PartnerChart/index.vue';
import UnitsChart from '@/components/Stats/MarketStats/ProfileStats/UnitChart/index.vue';

@Component({
  components: {
    'restaurant-chart': RestaurantsChart,
    'unit-chart': UnitsChart,
  },
})
export default class ProfileStats extends Vue {
  @PropSync('restaurantLists', {}) restaurantList!: any;

  @PropSync('unitLists', {}) unitList!: any;

  @PropSync('marketSelected', {}) selectedMarket!: any;

  mounted() {}
}
